import React from "react";
var __jsx = React.createElement;
import useBenefitAuth from "@lib/hooks/use-auth";
import IframeLogin from "@modules/shared/components/iframes/login";
import { createContext, useContext, useState } from "react";
import { permissionsManager } from "@lib/permissions/permissions-manager";
const BenefitIframeContext = /*#__PURE__*/createContext(null);
export const BenefitIframeProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    validateProviderLogin,
    loadingProviderValidation,
    iframeUrl,
    iframeOpen,
    setIframeOpen,
    openBenefitLogin,
    openBenefitRegister,
    token
  } = useBenefitAuth();
  const withoutEntityLogin = !permissionsManager.useEntityLogin();
  const {
    0: expired,
    1: setExpired
  } = useState(false);
  const {
    0: closable,
    1: setClosable
  } = useState(true);
  const handleOpenBenefitLogin = async (expired, closable) => {
    setExpired(expired !== null && expired !== void 0 ? expired : false);
    setClosable(closable !== null && closable !== void 0 ? closable : true);
    await openBenefitLogin();
  };
  const handleOpenBenefitRegister = async (expired, closable) => {
    setExpired(expired !== null && expired !== void 0 ? expired : false);
    setClosable(closable !== null && closable !== void 0 ? closable : true);
    await openBenefitRegister();
  };
  const handleValidateProviderLogin = (code, userId, isExpiredSession) => {
    validateProviderLogin(code, userId, isExpiredSession);
  };
  return __jsx(BenefitIframeContext.Provider, {
    value: {
      openBenefitLogin: handleOpenBenefitLogin,
      iframeOpen,
      token
    }
  }, children, __jsx(IframeLogin, {
    openState: iframeOpen,
    setOnOpenState: setIframeOpen,
    src: iframeUrl !== null && iframeUrl !== void 0 ? iframeUrl : "",
    loading: loadingProviderValidation,
    validate: handleValidateProviderLogin,
    width: "100%",
    isExpiredSession: !withoutEntityLogin ? expired : false,
    closable: closable
  }));
};
export const useBenefitLogin = () => {
  const context = useContext(BenefitIframeContext);
  if (context === null) {
    throw new Error("useBenefitLogin must be used within a BenefitIframeProvider");
  }
  return context;
};